/**
 * IntelFilterSelects — the category options of the intel-sources list filter (rendered by `ui/FilterSelect` in the
 * Toolbar right slot; demo /tables/data-tables header selects, NextAdmin `last-transactions-table`).
 */
import type { FilterOption } from '../../../components/ui/FilterSelect.js';

export const CATEGORY_OPTIONS: FilterOption[] = [
  { value: 'social', label: 'Social' },
  { value: 'on_chain', label: 'On-chain' },
  { value: 'institutional', label: 'Institutional' },
  { value: 'research', label: 'Research' },
  { value: 'defi', label: 'DeFi' },
  { value: 'market_infra', label: 'Market infrastructure' },
];
